// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/services/controlplane/generate/websocket_client/websocket_client.go'
// This file is intended for version control.


export const Recipient = {
  RecipientUser: "user",
  RecipientModel: "model",
  RecipientSystem: "system",
};

// RecipientKey provides controlled references to Recipient values.
export type RecipientKey = typeof Recipient[keyof typeof Recipient];
